import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'

// Import and register global base components

const requireComponent = require.context(
  './components/base',
  false,
  /O[A-Z]\w+\.(vue|js)$/
)

requireComponent.keys().forEach(fileName => {
  const componentConfig = requireComponent(fileName)
  const componentName = fileName.replace(/^\.\/(.*)\.\w+$/, '$1')
  Vue.component(componentName, componentConfig.default || componentConfig)
})

Vue.config.productionTip = false

Vue.mixin({
  methods: {
    showOverlay(reference) {
      this.$refs[reference].open()
    },
    hideOverlay(reference) {
      this.$refs[reference].close()
    }
  }
})

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
